import SubmitQuestion from "../component/SubmitQuestion";
import {useContext, useEffect} from "react";
import {Context} from "../component/context";

export const Short = () => {
    const {meta, setMeta, problems, setProblems, path} = useContext(Context);

    useEffect(() => {
        if (path !== 'short') return
        setMeta({
            allow_typo: false,
            allow_space: false,
        })
    }, [path]);

    const onChange = (toChange) => {
        const m = {...meta};
        m[toChange] = !m[toChange];
        setMeta(m)
    }

    return <>
        <div className='w-full  h-screen overflow-x-scroll hidden templates' id='short'>
            <table className="overflow-x-auto [&_tr]: my-4">
                <thead className="bg-gray-100">
                <tr>
                    <th className="px-4 py-4 border text-xl">오타 허용</th>
                    <th className="px-4 py-4 border text-xl">띄어쓰기 무관</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="px-4 py-4 border text-xl">
                        <label>
                            <input onClick={() => onChange('allow_typo')} checked={meta.allow_typo} type='radio'/>
                            오타 허용
                        </label>
                    </td>
                    <td className="px-4 py-4 border text-xl">
                        <label>
                            <input onClick={() => onChange('allow_space')} checked={meta.allow_space} type='radio'/>
                            띄어쓰기 무관
                        </label>
                    </td>
                </tr>
                </tbody>
            </table>
            <SubmitQuestion title='단답형' problems={problems} setProblems={setProblems}/>
        </div>
    </>
}